var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.335,
    height: 119.421,
    viewBox: "0 0 184.335 119.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jaune-p",
    transform: "translate(-1598.778 -239.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M134.621,225.361c-2.722-3.7-5.165-7.21-8.355-9.8a173.971,173.971,0,0,0-21.1-14.109c-10.7-6.349-22.3-10.6-34.847-10.8-23.377-.372-42.329,10.391-59.4,25.076A42.588,42.588,0,0,0,2.642,226.1c-5.786,9.627-.8,19.231,10.438,20.021a25.879,25.879,0,0,0,11.2-1.522c10.955-4.454,21.651-9.543,32.482-14.306,3.768-1.658,7.638-3.083,12.865-5.174-3.682,9.111-2.566,12.388,4.173,16.526a23.6,23.6,0,0,0,4.538,2.265c13.478,4.644,27.4,6.093,41.321,3.429a26.5,26.5,0,0,0,14-7.876c5.2-5.473,1.893-12.415.96-14.1",
    transform: "translate(1599.408 49.304)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M122.631,231.06c-15.929-3.866-32.066-3.054-47.316,3.659-8.4,3.7-9.715,7.3-7.351,16.693-2.539-.622-4.809-.832-6.762-1.729-3.847-1.76-7.382-4.238-11.289-5.823-10.562-4.285-21.049-8.956-31.954-12.14C8.843,229.056.268,233.91.007,241.777c-.161,4.9,2.351,10.84,5.577,14.73a83.236,83.236,0,0,0,54.5,29.828c28.33,3.624,50.84-10.876,70.348-29.254,9.853-9.282,5.426-22.811-7.8-26.02",
    transform: "translate(1599.282 71.475)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M84.308,220.185s21.6-16.971,47.828-4.628",
    transform: "translate(1650.765 60.378)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty1);
export default __webpack_public_path__ + "static/media/empty-1.9a478389606059f06fd793fa6a7e93fa.svg";
export { ForwardRef as ReactComponent };